const lang: Record<string, string> = {
    "nav.home": "Home",
    "nav.developer": "Developer",
    "nav.art": "Art",
    "construction.warning": "This page is under construction, as such, many pages and links are broken. And translations are still in progress.",
    "work.year": "Year",
    "work.price": "Price",
    "work.technique": "Medium",
    "work.dimensions": "Dimensions",
    "work.sold": "(Sold)",
    "expositions.title": "Expositions",
    "expositions.description": "Explore exhibitions featuring selected works.",
    "exposition.view": "View exposition"
    
};
export default lang
